import React from "react";

const I18nContext = React.createContext(null);

if (process.env.NODE_ENV !== "production") {
  I18nContext.displayName = "I18nContext";
}

export default I18nContext;
